// extracted by mini-css-extract-plugin
module.exports = {"attitudes-cell":"yMru1","attitudes-cell_exp":"K8B-O","attitudes-cell_attitudes":"CUzja"};